export function toMoney(value: string | number) {
	var formatter = new Intl.NumberFormat('pt-br', {
		style: 'currency',
		currency: 'BRL'
	})

	return formatter.format(parseFloat(value.toString())) 
}
